import { pxToRem } from '../../../../utils';
var sizeToPxValue = {
  smallest: 6,
  smaller: 10,
  small: 10,
  medium: 10,
  large: 10,
  larger: 16,
  largest: 0
};
export var getSizeStyles = function getSizeStyles(sizeInPx) {
  var sizeInRem = pxToRem(sizeInPx);
  return {
    height: sizeInRem,
    width: sizeInRem
  };
};
export var avatarStatusStyles = {
  root: function root(_ref) {
    var v = _ref.variables,
        _ref$props = _ref.props,
        color = _ref$props.color,
        size = _ref$props.size,
        state = _ref$props.state;
    return Object.assign({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center'
    }, getSizeStyles(sizeToPxValue[size]), {
      verticalAlign: 'middle',
      borderRadius: '9999px',
      position: 'absolute',
      bottom: 0,
      right: 0,
      boxShadow: "0 0 0 " + v.statusBorderWidth + " " + v.statusBorderColor
    }, state === 'success' && {
      backgroundColor: v.statusSuccessBackgroundColor
    }, state === 'info' && {
      backgroundColor: v.statusInfoBackgroundColor
    }, state === 'warning' && {
      backgroundColor: v.statusWarningBackgroundColor
    }, state === 'error' && {
      backgroundColor: v.statusErrorBackgroundColor
    }, state === 'unknown' && {
      backgroundColor: v.statusBackgroundColor
    }, !!color && {
      backgroundColor: color
    });
  }
};
//# sourceMappingURL=avatarStatusStyles.js.map
